/**
 * Constants representing sources that can control the state of the MegaScreen application,
 * inclulding the "runstate" (position in a playlist, number of votes in a poll, etc).
 */
export class AppStateSource {}
/**
 * The MANUAL AppStateSource indicates that commands from MRTS attempting to set the current
 * MegaScreen application state should be ignored. Instead, the application state will be determined
 * directly, typically through the Simulator instance (MegaScreen.globals.simulator). The Simulator
 * instance can be configured to control the app state via keyboard input or an external app such as
 * Director. Director, for example, uses MegaScreen with a MANUAL AppStateSource to render scene
 * previews.
 */
AppStateSource.MANUAL = 'manual';

/**
 * The standard AppStateSource, where MegaScreen's application state is controlled by MRTS (over a
 * socket connection).
 */
AppStateSource.MRTS = 'mrts';
